export const isPdfEncrypted = async (file: File) => {
  const chunkSize = 25600;
  const encryptMarker = /\/Encrypt\s+\d+\s+\d+\s+R/;

  try {
    const head = await file.slice(0, chunkSize).text();
    const tail = await file.slice(Math.max(0, file.size - chunkSize)).text();
    return encryptMarker.test(head) || encryptMarker.test(tail);
  } catch {
    return false;
  }
};
